import PropTypes from "prop-types";
import "./MultiColumnBrowser.css";
import {Component} from "react";
import {Button, Input, InputGroup} from "reactstrap";

const prefix="MultiColumnBrowserColumn";

const filterString = str => String(str)
	.toLowerCase()
	.replace(/[^a-z0-9._àèéìòù -]+/g,' ')
	.replace(/ +/g,' ')
	.replace(/^ /,'');

/** @type {MultiColumnBrowserOptionItemComponent} */
const MultiColumnBrowserOption = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
		if (props.filter) {
			const filter = props.filter.trim();
			const s = filterString(props.label).trim();
			if ( ! s.includes(filter)) this.state.hidden = true;
		}
		this.className = this.className.bind(this);
	}
	className() {
		const cn = ["MultiColumnBrowserOption"];
		if ( this.props.selected ) cn.push('selected');
		if ( this.props.disabled ) cn.push('disabled');
		return cn.join(' ');
	}
	render() {
		if ( this.state.hidden ) return null;
		return (
			<div
				className={this.className()}
				onClick={this.props.onClick}
				title={ this.props.title || this.props.label }
			>
				<div>
					{ this.props.icon && <i>{this.props.icon}</i> }
					{ this.props.label }
				</div>
			</div>
		)
	}
}

/** @type {MultiColumnBrowserColumnComponent} */
const MultiColumnBrowserColumn = class extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		options: PropTypes.arrayOf(PropTypes.object).isRequired,
		onClick: PropTypes.func,
		title: PropTypes.any,
		/** If true/truish column is filtered, if a string the string will be input field search placeholder */
		filter: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	}
	constructor(props) {
		super(props);
		const style = props.style ?? {};
		if ( props.width ) {
			if ( typeof props.width === "number" ) {
				style.width = style.minWidth = style.maxWidth = String(props.width)+'px';
			} else if ( typeof props.width === "string" ) {
				style.width = style.minWidth = style.maxWidth = props.width;
			}
		}
		const cn = [prefix];
		if ( props.className ) cn.push(props.className);
		if ( ! props.options || ! Array.isArray(props.options) || props.options.length === 0 ) cn.push('empty');
		if ( typeof props.onClick === "function" ) cn.push('clickable');
		this.state = {
			className: cn.join(' '),
			style: style,
			options: Array.isArray(props.options) ? props.options : [],
			selectedIndex: -1
		}
		this.onClick = this.onClick.bind(this);
	}
	onClick = (o,i) => {
		const ns = {};
		let selected = null;
		const opts = this.state.options.map( opt => {
			opt.selected = false;
			return opt;
		});
		if ( i === this.state.selectedIndex ) {
			ns.selectedIndex = -1;
		} else {
			ns.selectedIndex = i;
			opts[i].selected = true;
			selected = opts[i];
		}
		ns.options = opts;
		this.setState( ns, ()=>{
			if ( typeof this.props.onClick === 'function' ) {
				this.props.onClick( selected )
			}
		});
	}
	render() {
		return(
			<div
				className={this.state.className}
				style={this.state.style}
			>
				<div>
					{ (!!this.props.title) && (
						<h4>
							<span className={"title"}>{ this.props.title }</span>
							{ (this.props.filter && this.state.options.length > 3) && (
								<InputGroup>
									<Input
										type={"text"}
										placeholder={ typeof this.props.filter === "string" ? this.props.filter : "Filter"}
										value={this.state.filter||''}
										onChange={ e => {
											this.setState({ filter: filterString(e.target.value||'') });
										}}
									/>
									<Button
										color={"warning"}
										disabled={ ! this.state.filter }
										onClick={ ()=>{ this.setState({ filter: '' }) } }
									>
										<label />
									</Button>
								</InputGroup>
							)}
						</h4>
					)}
					<div className={"area"}>
						{ (this.state.options.length > 0) && this.state.options.map((option, i) => (
							<MultiColumnBrowserOption
								key={String(this.state.filter)+(option.label||option.value)}
								onClick={ ()=> this.onClick(option,i) }
								filter={ this.state.filter }
								{...option}
							/>
						))}
					</div>
				</div>
			</div>
		)
	}
}

export default MultiColumnBrowserColumn;